var _rect, _path, _rect2, _path2, _path3, _rect3, _path4, _path5, _rect4, _path6, _path7, _rect5, _path8, _path9, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveBookReading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 138,
    viewBox: "0 0 291 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 36 138)",
    fill: "#24284E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 110H206V134H98V110Z",
    fill: "#F15651"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 110,
    width: 32,
    height: 24,
    rx: 8,
    fill: "#F15651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206 114L206 130L114 130C111.791 130 110 128.209 110 126L110 118C110 115.791 111.791 114 114 114L206 114Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123 38H190V62H123V38Z",
    fill: "#F15651"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 38,
    width: 32,
    height: 24,
    rx: 8,
    fill: "#F15651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190 42L190 58L135 58C132.791 58 131 56.2091 131 54L131 46C131 43.7909 132.791 42 135 42L190 42Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187 90H107V110H187V90Z",
    fill: "#FFC844"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 8,
    transform: "matrix(-1 0 0 1 203 90)",
    fill: "#FFC844"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107 94L107 106L171 106C173.209 106 175 104.209 175 102L175 98C175 95.7909 173.209 94 171 94L107 94Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158 18H100V38H158V18Z",
    fill: "#FFC844"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 8,
    transform: "matrix(-1 0 0 1 174 18)",
    fill: "#FFC844"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100 22L100 34L142 34C144.209 34 146 32.2091 146 30L146 26C146 23.7909 144.209 22 142 22L100 22Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62H182V90H110V62Z",
    fill: "#A1498C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 62,
    width: 32,
    height: 28,
    rx: 8,
    fill: "#A1498C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182 66L182 86L125 86C122.791 86 121 84.2091 121 82L121 70C121 67.7909 122.791 66 125 66L182 66Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216 0C215.068 1.67884 213.679 3.06841 212 4C213.679 4.93159 215.068 6.32117 216 8C216.932 6.32117 218.321 4.93159 220 4C218.321 3.06841 216.932 1.67884 216 0Z",
    fill: "#FFEBBD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287 106C286.068 107.679 284.679 109.068 283 110C284.679 110.932 286.068 112.321 287 114C287.932 112.321 289.321 110.932 291 110C289.321 109.068 287.932 107.679 287 106Z",
    fill: "#FFEBBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10C21.0684 11.6788 19.6788 13.0684 18 14C19.6788 14.9316 21.0684 16.3212 22 18C22.9316 16.3212 24.3212 14.9316 26 14C24.3212 13.0684 22.9316 11.6788 22 10Z",
    fill: "#FFEBBD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 106C3.06841 107.679 1.67882 109.068 0 110C1.67882 110.932 3.06841 112.321 4 114C4.93159 112.321 6.32118 110.932 8 110C6.32118 109.068 4.93159 107.679 4 106Z",
    fill: "#FFEBBD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 64C48.5342 64.8394 47.8394 65.5342 47 66C47.8394 66.4658 48.5342 67.1606 49 68C49.4658 67.1606 50.1606 66.4658 51 66C50.1606 65.5342 49.4658 64.8394 49 64Z",
    fill: "#FFEBBD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 6C78.5342 6.83942 77.8394 7.53421 77 8C77.8394 8.46579 78.5342 9.16058 79 10C79.4658 9.16058 80.1606 8.46579 81 8C80.1606 7.53421 79.4658 6.83942 79 6Z",
    fill: "#FFEBBD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247 62C246.534 62.8394 245.839 63.5342 245 64C245.839 64.4658 246.534 65.1606 247 66C247.466 65.1606 248.161 64.4658 249 64C248.161 63.5342 247.466 62.8394 247 62Z",
    fill: "#FFEBBD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 6C288.534 6.83942 287.839 7.53421 287 8C287.839 8.46579 288.534 9.16058 289 10C289.466 9.16058 290.161 8.46579 291 8C290.161 7.53421 289.466 6.83942 289 6Z",
    fill: "#FFEBBD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225 100L249.5 94",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 99.5L41.5 93",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45.5L63.5 35.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M212 48.5L225 41",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130 75H142V81L136 77L130 81V75Z",
    fill: "#FFC844"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118 117H130V123L124 119L118 123V117Z",
    fill: "#A1498C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveBookReading);
export default __webpack_public_path__ + "static/media/collective-book-reading.3dfdadfb93e76486dfae46c775dbb5a3.svg";
export { ForwardRef as ReactComponent };